// extracted by mini-css-extract-plugin
export default {"page":"V0-z","cartModal":"W0-z","checkout":"X0-z","placeholder":"Y0-z","account":"Z0-z"};